// extracted by mini-css-extract-plugin
module.exports = {"card":"homecard-module--card--2BHAt","showcaseCard":"homecard-module--showcase-card--1AdSe"};